import { AfterViewInit, ElementRef, EventEmitter, Renderer2 } from '@angular/core';
import { FormControl } from '@angular/forms';
var FcOutlinedTextareaComponent = /** @class */ (function () {
    function FcOutlinedTextareaComponent(renderer) {
        this.renderer = renderer;
        this.next = new EventEmitter();
    }
    FcOutlinedTextareaComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.adjustTextareaHeight();
        this.control.valueChanges.subscribe(function () {
            _this.adjustTextareaHeight();
        });
    };
    FcOutlinedTextareaComponent.prototype.adjustTextareaHeight = function () {
        var textarea = this.textareaElement.nativeElement;
        this.renderer.setStyle(textarea, 'height', textarea.scrollHeight + 'px');
    };
    return FcOutlinedTextareaComponent;
}());
export { FcOutlinedTextareaComponent };
